import 'pixi-spine';
/* eslint-disable */
import { sound } from '@pixi/sound';
/* eslint-disable */
import '@pixi/events';
import { parseQuery } from '../helpers/parseQuery';
import { specificLocalStorageKeys } from '../constants/gameConstants';
import { userInfoStore } from '../../store/userInfoStore';
import { gameName } from '../constants/gameConfigsAndUrls';
import { userSettingsStore } from '../../store/userSettingsStore';
import { isMobile } from '../helpers/isMobile';
import { applicationStore } from '../../store/applicationStore';

export const init = () => {
  const query = parseQuery(window.location.search);
  const {
    playerexternalid,
    currency,
    token,
    replaymode,
    currencysymbol,
    skipspinafterbetchange,
    checkbalanceonbet,
  } = query;
  userInfoStore.setIsReplay(Boolean(replaymode));
  userInfoStore.setCurrencySymbolOrCode(currency);
  userInfoStore.setCurrencyIcon(currencysymbol || currency);
  userInfoStore.setUserId(playerexternalid);
  userInfoStore.setBetReplayTokenBySpin(token);
  applicationStore.setIsSkipSpinAfterBetChange(skipspinafterbetchange);
  applicationStore.setIsCheckBalanceOnBet(Boolean(+checkbalanceonbet));

  document.documentElement.classList.add(`is-${isMobile() ? 'mobile' : 'web'}`);

  userSettingsStore.localStorageAndUserSettingsInit({
    gameName,
    soundService: {},
    gameSpecificData: { [specificLocalStorageKeys.isHideIntro]: false },
  });
};
